<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>

        <app-navbar></app-navbar>
        <div class="container mt-5">
          <div class="row" style="margin-right: 0px;margin-left: 0px;">
            <div class="heading col-md-12">
              <vs-breadcrumb
                align="left"
                :items="
              [
                {title: 'You are here : '},
                {
                  title: 'Dashboard',
                  url: '/#/dashboard/program-officer/todoList'
                },
                {
                  title: this.trainingTitle,
                  url: '/#/dashboard/program-officer/todoList'
                },
                {
                  title: 'Assessment',
                  active: true
                }
              ]
                "
              ></vs-breadcrumb>
              <h3 class="text-secondary">Assessment</h3>
            </div>
          </div>
          <!-- <div class="col-sm-12 p-0 mb-4">
            <span style="font-weight:bold">
              Form Complete : 20%
              <vs-progress :percent="20" color="primary">primary</vs-progress>
            </span>
          </div>-->
          <!-- training title name section starts -->
          <div class="form-group form-row text-dark">
            <h6 class="sub-frm-title">Event Information</h6>
            <div class="row col-sm-12">
              <label class="col-sm-1 font-weight-bold" style="color:#6c757d;">
                <h5>Title:</h5>
              </label>
              <div class="col-sm-11" style="color:#6c757d;">
                <h5 v-if="trainingTitle">{{trainingTitle}}</h5>
              </div>
            </div>
            <div class="row col-sm-12">
              <label class="col-sm-2 font-weight-bold" style="padding:0px 0px 0px 15px">
                <h6>Start Date:</h6>
              </label>
              <h6
                class="col-sm-2"
                style="padding:0px 0px 0px 15px;color:#6c757d;"
                v-if="startDate"
              >{{startDate}}</h6>

              <label class="col-sm-2 font-weight-bold p-0">
                <h6>End Date:</h6>
              </label>
              <h6 class="col-sm-4 p-0" style="color:#6c757d;" v-if="endDate">{{endDate}}</h6>
            </div>
          </div>
          <!-- training title name section ends -->

          <!-- training question selection section starts -->
          <div class="row form-row text-dark" v-if="addPreassessmentForm == true">
            <h6 class="sub-frm-title">Add Assessment Questions</h6>
            <!-- <form @submit.prevent="submitForm"> -->
            <div class="row form-row">
            <div class="col-md-6">
              <label style="color: #07a7e19c !important;" for="no_of_question">
                <b>No. of question(s)</b>
                 <span style="color:rgba(255, 0, 0, 0.78);">*</span>
              </label>
              <input
                type="number"
                min="1"
                v-model="no_of_question"
                class="form-control"
                placeholder="Enter no. of questions you want to add to assessment..."
              />
            </div>
            </div>
            <!-- filters starts -->
            <div style="width:100%;">
              <vs-collapse accordion>
                <vs-collapse-item>
                  <div slot="header" style="margin:5px 0px;">
                    <vs-button color="primary" type="filled">Use Filter</vs-button>
                  </div>
                  <div
                    class="row"
                    style="background-color:#f3f3f3;border-radius:5px;margin:20px 0px;width:100%;"
                  >
                    <div class="col-md-4">
                      <p style="margin-bottom:0px;" class="mt-1">
                        <b>Thematic Area</b>
                      </p>
                      <div class="mt-2">
                        <!-- <label style="padding-left: 5px;font-size:.85rem;">Thematic Area</label> -->
                        <vs-row v-if="thematicArr">
                          <vs-col
                            vs-type="flex"
                            vs-justify="left"
                            vs-align="center"
                            vs-w="3"
                            v-for="(item,index) in thematicArr"
                            v-bind:key="index"
                          >
                            <!-- chip starts  -->
                            <div class="centerx">
                              <vs-chip color="#24c1a0" style="font-size:12pxmargin-right: 0px !important;padding: 8px !important;text-align:center;">{{item.name}}</vs-chip>
                            </div>
                            <!-- chip ends  -->
                          </vs-col>
                        </vs-row>
                      </div>
                    </div>
                    <div class="col-md-4 level-radios" style="text-align:center;">
                      <p style="margin-bottom:0px;" class="mt-1">
                        <b>Question Level</b>
                      </p>
                      <ul class="leftx mt-2" style="display:inline-flex;">
                        <li>
                          <vs-radio v-model="radios1" vs-value="6">Basic</vs-radio>
                        </li>
                        <li>
                          <vs-radio v-model="radios1" vs-value="7">Intermediate</vs-radio>
                        </li>
                        <li>
                          <vs-radio v-model="radios1" vs-value="8">Advance</vs-radio>
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-4">
                      <p style="text-align:center;margin-bottom:0px;" class="mt-1">
                        <b>Previous  Event</b>
                      </p>
                      <div class="mt-2">
                        <selectize
                          id="select-state"
                          v-model="previoustrainingSelected"
                          :settings="previoustrainingSettings"
                        >
                          <option
                            v-for="(item,index) in previousTrainingArr"
                            :key="index"
                            :value="item.id"
                          >{{item.title}}</option>
                        </selectize>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="text-center" style="margin-bottom:10px;">
                        <b-button
                          pill
                          variant="outline-primary"
                          @click="filterQuestions()"
                          size="sm"
                          class="mr-1"
                        >Search</b-button>
                        <b-button
                          class="mr-1"
                          pill
                          variant="ouline-success"
                          @click="resetFormElements()"
                          size="sm"
                        >Reset</b-button>
                      </div>
                    </div>
                  </div>
                </vs-collapse-item>
              </vs-collapse>
            </div>

            <!-- filters ends -->
            <div class="col-sm-12 mb-2 mt-3">
              <!-- nested row starts  -->
              <div class="row">
                <!-- nested column starts  -->
                <div class="col-sm-6">
                  <h5 style="color:rgb(108, 117, 125);">Question Level Percentage</h5>
                  <vs-row>
                    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="3">
                      <!-- chip starts  -->
                      <div class="centerx">
                        <vs-chip color="success" style="font-size:15px;text-align:center">
                          <Strong style="font-size:15px; padding-right:5px;">B :</Strong>
                          {{easyPercent}}%
                        </vs-chip>
                      </div>
                      <!-- chip ends  -->
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="3">
                      <!-- chip starts  -->
                      <div class="centerx">
                        <vs-chip color="#ffc107" style="text-align:center;font-size:15px;padding: 6px !important;">
                          <Strong style="font-size:15px;">I :</Strong>
                          {{mediumPercent}}%
                        </vs-chip>
                      </div>
                      <!-- chip ends  -->
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="3">
                      <!-- chip starts  -->
                      <div class="centerx">
                        <vs-chip color="danger" style="font-size:15px;text-align:center">
                          <Strong style="font-size:15px; padding-right:5px;">A :</Strong>
                          {{hardPercent}}%
                        </vs-chip>
                      </div>
                      <!-- chip ends  -->
                    </vs-col>
                  </vs-row>
                </div>
                <!-- nested column ends  -->
                <!-- ------------------------------  -->
                <!-- nested column starts  -->
                <div class="col-sm-6">
                  <h5 style="color:rgb(108, 117, 125);">Thematic Area</h5>
                  <vs-row v-if="thematicArr">
                    <vs-col
                      vs-type="flex"
                      vs-justify="left"
                      vs-align="center"
                      vs-w="3"
                      v-for="(item,index) in thematicArr"
                      v-bind:key="index"
                    >
                      <!-- chip starts  -->
                      <div class="centerx">
                        <vs-chip color="#24c1a0" style="font-size:12pxmargin-right: 0px !important;padding: 8px !important;text-align:center;">{{item.name}}</vs-chip>
                      </div>
                      <!-- chip ends  -->
                    </vs-col>
                  </vs-row>
                </div>
                <!-- nested column ends  -->
              </div>
              <!-- nested row ends  -->
            </div>
            <!-- Repository Starts -->
            <div
              class="col-sm-6 mt-5"
              style="border: 1px dotted #07a7e14f;"
              v-if="questionForm == true"
            >
              <div class="mb-3 repository-title">Repository</div>
              <div v-for="(item,index) in allQuestionsArr" v-bind:key="index">
                <!-- question Starts -->

                <b-card class="mb-3">
                  <b-card-text>
                    <h6>
                      <strong>Q {{index+1}})</strong>
                      {{item[0].qtitle}}
                      <span></span>
                    </h6>
                  </b-card-text>
                  <div>
                    <b-badge
                      class="p-2 mr-1"
                      href="#"
                      variant="secondary"
                      v-if="item[0].qfrequency != null"
                    >F : {{item[0].qfrequency}}</b-badge>
                    <b-badge class="p-2 mr-1" href="#" variant="secondary" v-else>F : 0</b-badge>
                    <b-badge
                      class="p-2 mr-1 mb-2"
                      href="#"
                      variant="success"
                      v-if="item[0].qlevel == 6"
                    >B</b-badge>
                    <b-badge
                      class="p-2 mr-1 mb-2"
                      href="#"
                      variant="warning"
                      v-else-if="item[0].qlevel == 7"
                    >I</b-badge>
                    <b-badge
                      class="p-2 mr-1 mb-2"
                      href="#"
                      variant="danger"
                      v-else-if="item[0].qlevel == 8"
                    >A</b-badge>
                    <b-button
                      v-b-toggle="index+1"
                      class="mr-1"
                      href="#"
                      size="sm"
                      variant="outline-success"
                    >Correct Ans</b-button>

                    <!-- Element to collapse -->
                    <b-collapse
                      :id="index+1"
                      class="mb-3"
                      v-for="(option, index2) in item[1]"
                      v-bind:key="index2"
                    >
                      <b-card v-if="option.opstatus == 1">{{ option.otitle }}</b-card>
                    </b-collapse>
                    <b-button
                      style="float:right;"
                      id="moveButton"
                      href="#"
                      @click="moveQuestion(index,item[0].qid)"
                      size="sm"
                      variant="primary"
                    >Add</b-button>
                  </div>
                </b-card>
                <!-- question Ends -->
              </div>
              <!-- <div>
                <vs-pagination :total="10" v-model="currentx"></vs-pagination>
              </div>-->
            </div>
            <!-- Repository Ends -->
            <!-- Filtered Question started -->
            <div
              class="col-sm-6 mt-5"
              style="border: 1px dotted #07a7e14f;"
              v-if="filterForm == true"
            >
              <div class="mb-3 filtered-title">Filtered Repo</div>
              <span v-if="allQuestionsArr.length > 0">
                <div v-for="(item,index) in allQuestionsArr" v-bind:key="item[0].qid">
                  <!-- question Starts -->
                  <b-card class="mb-3">
                    <b-card-text>
                      <h6>
                        <strong>Q {{index+1}})</strong>
                        {{item[0].qtitle}}
                        <span></span>
                      </h6>
                    </b-card-text>
                    <div>
                      <b-badge
                        class="p-2 mr-1"
                        href="#"
                        variant="secondary"
                        v-if="item[0].qfrequency != null"
                      >F : {{item[0].qfrequency}}</b-badge>
                      <b-badge class="p-2 mr-1" href="#" variant="secondary" v-else>F : 0</b-badge>

                      <b-badge
                        class="p-2 mr-1 mb-2"
                        href="#"
                        variant="success"
                        v-if="item[0].qlevel == 6"
                      >B</b-badge>
                      <b-badge
                        class="p-2 mr-1 mb-2"
                        href="#"
                        variant="warning"
                        v-else-if="item[0].qlevel == 7"
                      >I</b-badge>
                      <b-badge
                        class="p-2 mr-1 mb-2"
                        href="#"
                        variant="danger"
                        v-else-if="item[0].qlevel == 8"
                      >A</b-badge>

                      <b-button
                        v-b-toggle="index+1"
                        class="mr-1"
                        href="#"
                        size="sm"
                        variant="outline-success"
                      >Correct Ans</b-button>

                      <!-- Element to collapse -->
                      <b-collapse
                        :id="index+1"
                        class="mb-3"
                        v-for="(option, index2) in item[1]"
                        v-bind:key="index2"
                      >
                        <b-card v-if="option.opstatus == 1">{{ option.otitle }}</b-card>
                      </b-collapse>
                      <b-button
                        style="float:right;"
                        href="#"
                        size="sm"
                        @click="moveQuestion(index,item[0].qid)"
                        variant="primary"
                      >Add</b-button>
                    </div>
                  </b-card>
                  <!-- question Ends -->
                </div>

                <!-- <div>
                <vs-pagination :total="10" v-model="currentx"></vs-pagination>
                </div>-->
                
              </span>
              <span class="text-danger" v-else>
                <b>Warning! Questions were not found according to search.</b>
              </span>
            </div>
            <!-- End of Filtered questions -->
            <!-- Selected questions Starts -->
            <div class="col-sm-6 mt-5" style="border: 1px dotted #07a7e14f; border-left:none;">
              <div class="mb-3 ml-1 selected-title">Selected</div>

              <div v-if="selectedQuestionsArr.length > 0">
                <!-- question selected Starts -->
                <div
                  v-for="(item,index) in selectedQuestionsArr"
                  v-bind:key="index"
                  id="scrollToQuestion"
                >
                  <!-- question Starts -->
                  <b-card class="mb-3">
                    <b-card-text>
                      <h6>
                        <strong>Q {{index+1}})</strong>
                        {{item[0].qtitle}}
                        <span></span>
                      </h6>
                    </b-card-text>
                    <div>
                      <b-badge
                        class="p-2 mr-1"
                        href="#"
                        variant="secondary"
                        v-if="item[0].qfrequency != null"
                      >F : {{item[0].qfrequency + 1}}</b-badge>
                      <b-badge class="p-2 mr-1" href="#" variant="secondary" v-else>F : 1</b-badge>

                      <b-badge
                        class="p-2 mr-1 mb-2"
                        href="#"
                        variant="success"
                        v-if="item[0].qlevel == 6"
                      >B</b-badge>
                      <b-badge
                        class="p-2 mr-1 mb-2"
                        href="#"
                        variant="warning"
                        v-else-if="item[0].qlevel == 7"
                      >I</b-badge>
                      <b-badge
                        class="p-2 mr-1 mb-2"
                        href="#"
                        variant="danger"
                        v-else-if="item[0].qlevel == 8"
                      >A</b-badge>

                      <b-button
                        v-b-toggle="index+1"
                        class="mr-1"
                        href="#"
                        size="sm"
                        variant="outline-success"
                      >Correct Ans</b-button>

                      <!-- Element to collapse -->
                      <b-collapse
                        :id="index+1"
                        class="mb-3"
                        v-for="(option, index2) in item[1]"
                        v-bind:key="index2"
                      >
                        <b-card v-if="option.opstatus == 1">{{ option.otitle }}</b-card>
                      </b-collapse>
                      
                      <b-button
                        style="float:right;"
                        href="#"
                        size="sm"
                        @click="removeQuestion(index)"
                        variant="danger"
                      >Remove</b-button>
                    </div>
                  </b-card>
                  <!-- question Ends -->
                </div>
                <!-- question selected Ends -->
                <div v-if="this.showAssessmentTable == true">
                <div class="mb-5">
                  <b-button
                    id="mybutton"
                    @click="submitForm()"
                    variant="primary"
                    style="float:right;"
                    size="sm"
                  >Submit</b-button>
                </div>
                </div>
                <div v-else-if="this.showAssessmentTable == false">
                  <div class="mb-5">
                  <b-button
                    id="mybutton"
                    @click="submitEditForm()"
                    variant="primary"
                    style="float:right;"
                    size="sm"
                  >Update</b-button>
                    <b-button variant="outline-dark" @click="isExistPreAssessment()" class="mr-1 float-right" size="sm">Cancel</b-button>
                </div>
                </div>
              </div>
              <div class="text-center" style="margin-top: 30px;" v-else>
                <b class="text-danger">Warning! No question was selected yet.</b>
              </div>
            </div>
            <!-- Selected questions Ends -->
            <!-- </form> -->
            <!-- </div> -->
            <!-- training question selection section ends -->
          </div>
          <div v-else-if="existPreassessmentForm == true">
            <h6 class="sub-frm-title">Assessment has been created for this training.</h6>
            
            <div class="col-sm-12 mb-2 mt-3">
              <!-- nested row starts  -->
              <div class="row">
                <div class="col-sm-8">
                  <h6 style="color:rgb(108, 117, 125);">Question Level Percentage</h6>
                  <vs-row>
                    <vs-col vs-type="flex" vs-align="center" vs-w="3">
                      <!-- chip starts  -->
                      <div class="centerx">
                        <vs-chip color="success" style="font-size:15px;">
                          <Strong style="font-size:15px; padding-right:5px;">Basic :</Strong>
                          {{assessmentShowArr[0].easy_percent}}%
                        </vs-chip>
                      </div>
                      <!-- chip ends  -->
                    </vs-col>
                    <vs-col vs-type="flex" vs-align="center" vs-w="3">
                      <!-- chip starts  -->
                      <div class="centerx">
                        <vs-chip color="#ffc107" style="font-size:15px;">
                          <Strong style="font-size:15px; padding-right:5px;">Intermediate :</Strong>
                          {{assessmentShowArr[0].medium_percent}}%
                        </vs-chip>
                      </div>
                      <!-- chip ends  -->
                    </vs-col>
                    <vs-col vs-type="flex" vs-align="center" vs-w="3">
                      <!-- chip starts  -->
                      <div class="centerx">
                        <vs-chip color="danger" style="font-size:15px;">
                          <Strong style="font-size:15px; padding-right:5px;">Advance :</Strong>
                          {{assessmentShowArr[0].hard_percent}}%
                        </vs-chip>
                      </div>
                      <!-- chip ends  -->
                    </vs-col>
                  </vs-row>
                </div>
              </div>
            </div>
          </div>

          <b-card v-if="assessmentShowArr.length > 0 & this.showAssessmentTable == true">
            <div class="form-group">
              <div class="row">
                <div class="col-sm-12 p-0">
                  <div class="table-responsive">
                    <div class="mb-1" style="float:right">
                      <b-button
                        variant="outline-primary"
                        class="mr-1"
                        size="sm"
                        @click="editAssesment()"
                      >Edit</b-button>
                      <b-button
                        @click="deleteAssesment()"
                        variant="outline-danger"
                        class="mr-1"
                        size="sm"
                      >Delete</b-button>
                    </div>
                    <table class="table">
                      <tr>
                        <th>Sr#</th>
                        <th>Question</th>
                        <th>Question Level</th>
                        <th>Added at</th>
                      </tr>
                      <tr v-for="(item,index) in assessmentShowArr" v-bind:key="index">
                        <td>{{index+1}}</td>
                        <td>{{item.question.title}}</td>
                        <td v-if="item.question.level == 6">Basic</td>
                        <td v-else-if="item.question.level == 7">Intermediate</td>
                        <td v-else-if="item.question.level == 8">Advance</td>
                        <td v-else>
                          <code>NULL</code>
                        </td>
                        <td>{{item.createdAt | formatDate}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import Navbar from "./Navbar";
import Sidebar from "./subSidebar";
import Selectize from "vue2-selectize";

import axios from "axios";
export default {
  data: () => ({
    trainingId: "",
    trainingCode: "",
    trainingTitle: "",
    startDate: "",
    endDate: "",
    no_of_question: "",
    allQuestionsArr: [],
    filteredQuestionsArr: [],
    selectedQuestionsArr: [],

    currentx: 1,
    currentx2: 1,
    radios1: "",
    value1: [0, 50],
    thematicArr: [],
    thematicSelected: "",
    thematicSettings: {
      maxItems: 5
    },
    previousTrainingArr: [],
    previoustrainingSelected: "",
    previoustrainingSettings: {
      maxItems: 3,
      plugins: ["remove_button"]
    },

    isSidebar: false,
    questionForm: true,
    filterForm: false,
    addPreassessmentForm: true,
    existPreassessmentForm: false,
    showAssessmentTable: false,
    easyPercent: 0,
    easyPercentArr: [],
    mediumPercent: 0,
    mediumPercentArr: [],
    hardPercent: 0,
    hardPercentArr: [],
    thematicSelectedShowArr: [],
    thematicSelectedShow: "",
    thematicId: "",
    assessmentShowArr: []
  }),
  components: {
    Selectize,
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.trainingCode = this.$route.query.trainingId;
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/programOfficer/trainingsingle/get/" +
          this.trainingCode
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
        this.closeLoading();
        this.trainingId = response.data.training.id;
        this.currentTraining();
        this.getPrevious();
        this.allQuestions();
        this.isExistPreAssessment();
        this.showAssessment();
      });
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 2000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 2000,
        variant: "danger",
        solid: true
      });
    },
    // this will reset form elements
    resetFormElements: function resetFormElements() {
      this.thematicSelected = "";
      this.radios1 = "";
      this.previoustrainingSelected = "";
      this.allQuestions();
    },
    addOtherAssesment() {
      this.allQuestions();
      this.addPreassessmentForm = true;
      this.showAssessmentTable = false;
    },
    editAssesment() {
      this.allQuestions();
      this.addPreassessmentForm = true;
      this.showAssessmentTable = false;
      this.no_of_question = this.assessmentShowArr.length;
      this.easyPercent = this.assessmentShowArr[0].easy_percent;
      this.mediumPercent = this.assessmentShowArr[0].medium_percent;
      this.hardPercent = this.assessmentShowArr[0].hard_percent;
      this.assessmentShowArr.map(val => {
        this.selectedQuestionsArr.push([
          {
            aid: val.id,
            qid: val.question.id,
            qtitle: val.question.title,
            qfrequency: val.question.frequency,
            qlevel: val.question.level,
          }
        ]);
      });
    },
    deleteAssesment() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/assessment/delete/id/" +
            this.assessmentShowArr[0].training_id
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if(response){
            this.addPreassessmentForm = true;
            this.assessmentShowArr = [];
            this.$toasted.global.successMsg("Assessment has been deleted successfully.");
          }
        });
    },
    // this will check if pre assessment already created or not
    isExistPreAssessment: function isExistPreAssessment() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/assessment/" +
            this.trainingId +
            "/check/get"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          this.closeLoading();
          this.selectedQuestionsArr = [];
          if (response.data.success != "" && response.data.success != null) {
            this.addPreassessmentForm = false;
            this.existPreassessmentForm = true;
            this.showAssessmentTable = true;
          } else {
            this.addPreassessmentForm = true;
            this.existPreassessmentForm = false;
          }
        });
    },
    filterQuestions() {
      if (this.radios1 != "" || this.previoustrainingSelected != "") {
        this.allQuestionsArr = [];
        this.questionForm = false;
        this.filterForm = true;
        this.openLoading();
        axios
          .post(
            localStorage.getItem("BASE_PATH") +
              "/admin/current-training/filter/get",
            {
              thematic: this.thematicId,
              level: this.radios1,
              priviousTraining: this.previoustrainingSelected
            }
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
            this.closeLoading();
            this.allQuestionsArr = response.data;
          });
      }
    },
    // this will show current training of a program officer
    currentTraining: function currentTraining() {
      let userId = JSON.parse(localStorage.getItem("currentUser"));
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/current-training/" +
            this.trainingId +
            "/" +
            userId.id +
            "/get"
       
        )
        .then(response => {
           if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          this.closeLoading();
          this.trainingTitle = response.data.title;
          this.startDate = response.data.startdate;
          this.endDate = response.data.enddate;
          this.thematicId = response.data.thematic_id;
          this.getThematic();
        });
    },
    // this will show thematic areas
    getThematic: function getThematic() {
      this.openLoading();
      axios
        .post(localStorage.getItem("BASE_PATH") + "/assessment/thematics/get", {
          thematic: this.thematicId
        }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.thematicArr = response.data;
        });
    },
    // this will show privious trainings
    getPrevious: function getPrevious() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/admin/all-training/" +
            this.trainingId +
            "/previous/get"
        
        )
        .then(response => {
         if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          this.closeLoading();
          this.previousTrainingArr = response.data;
        });
    },
    // this will show assessment which has been added
    showAssessment: function showAssessment() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/program-officer/training/assessment/" +
            this.trainingId +
            "/show"
        
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          this.closeLoading();
          this.assessmentShowArr = response.data;
          this.showAssessmentTable = true;
        });
    },
    // this will show all questions
    allQuestions: function allQuestions() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/admin/all-questions/assessment/get"
        
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          this.closeLoading();
          this.allQuestionsArr = [];
          response.data.forEach((quiz) => {
            if(quiz[0].qis_standard != "standard"){
              this.allQuestionsArr.push(quiz);
            }
          })
        });
    },
    // this will show selected questions
    async moveQuestion(val, qid) {
      if (this.no_of_question != "" && this.no_of_question != 0) {
        if (this.selectedQuestionsArr.length + 1 > this.no_of_question) {
          this.$toasted.global.errorMsg("Selected questions queue is full.");
          return false;
        } else {
          let checkValue = this.selectedQuestionsArr.some(function(value) {
            return value[0].qid == qid;
          });

          if (checkValue == true) {
            this.$toasted.global.errorMsg("Question was already moved.");
          } else {
            // this.moveScrollTo();
            this.$toasted.global.successMsg("Question moved successfully!");
            this.selectedQuestionsArr.push(this.allQuestionsArr[val]);
            this.allQuestionsArr.splice(val, 1);

            this.easyPercentArr = [];
            this.mediumPercentArr = [];
            this.hardPercentArr = [];
            this.selectedQuestionsArr.forEach(async element => {
              if (element[0].qlevel == 6) {
                await this.easyPercentArr.push(element);
              }
              if (element[0].qlevel == 7) {
                await this.mediumPercentArr.push(element);
              }
              if (element[0].qlevel == 8) {
                await this.hardPercentArr.push(element);
              }
            });
            this.easyPercent = Math.floor(
              (this.easyPercentArr.length / this.no_of_question) * 100
            );
            this.mediumPercent = Math.floor(
              (this.mediumPercentArr.length / this.no_of_question) * 100
            );
            this.hardPercent = Math.floor(
              (this.hardPercentArr.length / this.no_of_question) * 100
            );
          }
        }
      } else {
        this.$toasted.global.errorMsg("Enter no of questions you want to select.");
      }
    },
    // this will remove questions from selected queue
    removeQuestion(val) {
      this.allQuestionsArr.push(this.selectedQuestionsArr[val]);
      this.selectedQuestionsArr.splice(val, 1);
      this.$toasted.global.errorMsg("Question removed from selected!");

      this.easyPercentArr = [];
      this.mediumPercentArr = [];
      this.hardPercentArr = [];
      this.selectedQuestionsArr.forEach(async element => {
        if (element[0].qlevel == 6) {
          await this.easyPercentArr.push(element);
        }
        if (element[0].qlevel == 7) {
          await this.mediumPercentArr.push(element);
        }
        if (element[0].qlevel == 8) {
          await this.hardPercentArr.push(element);
        }
      });
      this.easyPercent = Math.floor(
        (this.easyPercentArr.length / this.no_of_question) * 100
      );
      this.mediumPercent = Math.floor(
        (this.mediumPercentArr.length / this.no_of_question) * 100
      );
      this.hardPercent = Math.floor(
        (this.hardPercentArr.length / this.no_of_question) * 100
      );
    },
    // This will submit pre assessment form
    submitForm() {
      if (this.no_of_question != this.selectedQuestionsArr.length) {
        this.$toasted.global.errorMsg(
          "Please check that no. of question is equal to selected question."
        );
      } else {
        let userId = JSON.parse(localStorage.getItem("currentUser"));
        this.openLoading();
        axios
          .post(
            localStorage.getItem("BASE_PATH") +
              "/admin/training/assessment/add",
            {
              saveSelected: this.selectedQuestionsArr,
              easy_percent: this.easyPercent,
              medium_percent: this.mediumPercent,
              hard_percent: this.hardPercent,
              training_id: this.trainingId,
              user_id: userId.id,
            }
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
            this.closeLoading();
            if (response.data.success) {
              // empty all varaibles
              this.allQuestionsArr = [];
              this.selectedQuestionsArr = [];
              this.questionForm = true;
              this.filterForm = false;
              this.thematicSelected = [];
              this.level = "";
              this.easyPercent = 0;
              this.mediumPercent = 0;
              this.hardPercent = 0;
              this.addPreassessmentForm = false;
              this.existPreassessmentForm = true;
              this.showAssessment();
              // End empty all varaibles
              this.$toasted.global.successMsg("Assessment has been created successfully.");
            } else {
              this.$toasted.global.errorMsg(
                "Error: Something went wrong while creating Assessment."
              );
            }
          });
      }
    },
    // This will submit edit assessment form
    submitEditForm() {
      if (this.no_of_question != this.selectedQuestionsArr.length) {
        this.$toasted.global.errorMsg(
          "Please check that no. of question is equal to selected question."
        );
      } else {
        let userId = JSON.parse(localStorage.getItem("currentUser"));
        this.openLoading();
        axios
          .post(
            localStorage.getItem("BASE_PATH") +
              "/admin/training/assessment/update",
            {
              saveSelected: this.selectedQuestionsArr,
              easy_percent: this.easyPercent,
              medium_percent: this.mediumPercent,
              hard_percent: this.hardPercent,
              training_id: this.trainingId,
              user_id: userId.id
            }
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
            this.closeLoading();
            if (response.data.success) {
              // empty all varaibles
              this.allQuestionsArr = [];
              this.selectedQuestionsArr = [];
              this.questionForm = true;
              this.filterForm = false;
              this.thematicSelected = [];
              this.level = "";
              this.easyPercent = 0;
              this.mediumPercent = 0;
              this.hardPercent = 0;
              this.addPreassessmentForm = false;
              this.existPreassessmentForm = true;
              this.showAssessment();
              // End empty all varaibles
              this.$toasted.global.successMsg("Assessment has been updated successfully.");
            } else {
              this.$toasted.global.errorMsg(
                "Error: Something went wrong while creating Assessment."
              );
            }
          });
      }
    }
  },
  // methods END now

  watch: {
    // thematicSelected(text){
    //   alert(text)
    //   this.showSelectedThematic();
    // },
    // radios1(){
    //   this.filterQuestions();
    // },
    // previoustrainingSelected() {
    //   this.filterQuestions();
    // },
    // this will check if no. of questions given in input is greater than questions selected in queue
    
    no_of_question() {
      if (
        this.selectedQuestionsArr.length > 0 &&
        this.no_of_question < this.selectedQuestionsArr.length
      ) {
        this.$toasted.global.errorMsg(
          "No. of questions in input, decreased from selected questions in queue."
        );
      } else if (
        this.selectedQuestionsArr.length > 0 &&
        this.no_of_question == this.selectedQuestionsArr.length
      ) {
        return true;
      } else if (this.no_of_question <= 0) {
        this.$toasted.global.errorMsg("Number of question(s) must be greater than zero.");
      } else {
        this.$toasted.global.successMsg("Now you can move questions.");
      }
    }
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.b-list-group-item.opt-list-item {
  border: none !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.level-radios ul li {
  padding: 3px;
}
.p-2 {
  padding: 12px !important;
}
.repository-title {
  width: 142px;
  padding: 0px 5px;
  color: rgba(7, 167, 225, 0.61);
  background-color: #fff;
  font-size: 28px;
  margin-top: -25px;
}
.filtered-title {
  width: 180px;
  padding: 0px 5px;
  color: rgba(7, 167, 225, 0.61);
  background-color: #fff;
  font-size: 28px;
  margin-top: -25px;
}
.selected-title {
  width: 115px;
  padding: 0px 5px;
  color: rgba(7, 167, 225, 0.61);
  background-color: #fff;
  font-size: 28px;
  margin-top: -25px;
}
.crd-title {
  font-size: 20px;
}
</style>
<style >
.vs-slider {
  background-color: #c9ddff !important;
}
.con-content--item {
  padding: 0px !important;
}
</style>
